export const AnswerUnits = {
    DAYS: "Days",
    HOURS: "Hours",
    INCHES: "Inches",
    MINUTES: "Minutes",
    PERCENTAGE: "%",
    POUNDS: "Pounds",
    SECONDS: "Seconds",
};
